var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2789_92822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2789_92822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2705 17.5C2.11772 17.5 1.97883 17.4618 1.85383 17.3854C1.72883 17.309 1.63161 17.2083 1.56216 17.0833C1.49272 16.9583 1.45452 16.8229 1.44758 16.6771C1.44063 16.5313 1.47883 16.3889 1.56216 16.25L9.27049 2.91667C9.35383 2.77778 9.46147 2.67361 9.59341 2.60417C9.72536 2.53472 9.86077 2.5 9.99966 2.5C10.1386 2.5 10.274 2.53472 10.4059 2.60417C10.5379 2.67361 10.6455 2.77778 10.7288 2.91667L18.4372 16.25C18.5205 16.3889 18.5587 16.5313 18.5517 16.6771C18.5448 16.8229 18.5066 16.9583 18.4372 17.0833C18.3677 17.2083 18.2705 17.309 18.1455 17.3854C18.0205 17.4618 17.8816 17.5 17.7288 17.5H2.2705ZM3.708 15.8333H16.2913L9.99966 5L3.708 15.8333ZM9.99966 15C10.2358 15 10.4337 14.9201 10.5934 14.7604C10.7531 14.6007 10.833 14.4028 10.833 14.1667C10.833 13.9306 10.7531 13.7326 10.5934 13.5729C10.4337 13.4132 10.2358 13.3333 9.99966 13.3333C9.76355 13.3333 9.56563 13.4132 9.40591 13.5729C9.24619 13.7326 9.16633 13.9306 9.16633 14.1667C9.16633 14.4028 9.24619 14.6007 9.40591 14.7604C9.56563 14.9201 9.76355 15 9.99966 15ZM9.99966 12.5C10.2358 12.5 10.4337 12.4201 10.5934 12.2604C10.7531 12.1007 10.833 11.9028 10.833 11.6667V9.16667C10.833 8.93056 10.7531 8.73264 10.5934 8.57292C10.4337 8.41319 10.2358 8.33333 9.99966 8.33333C9.76355 8.33333 9.56563 8.41319 9.40591 8.57292C9.24619 8.73264 9.16633 8.93056 9.16633 9.16667V11.6667C9.16633 11.9028 9.24619 12.1007 9.40591 12.2604C9.56563 12.4201 9.76355 12.5 9.99966 12.5Z",
    fill: "#ED6F26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyInfo);
export default __webpack_public_path__ + "static/media/SafetyInfo.57eaf8ed.svg";
export { ForwardRef as ReactComponent };